export default "__VITE_ASSET__Cwqq8OWw__"